$(function() {
    $('.interval__button').on('click', function (e) {
        var current = $(this).parent().parent().parent();

        if (current.hasClass('interval__item--hide')) {
            var all = current.parent().children('.interval__item');
            var scrolltarget = 0;

            all.each(function(index) {
                if (index === 0) {
                    scrolltarget = $(this).offset().top;
                }

                if ($(this).is(current)) {
                    return false;
                } else {
                    scrolltarget += $('.interval__head', $(this)).outerHeight(true);
                }
            });
            scrolltarget -= 120;
        }

        if (current.hasClass('interval__item--hide')) {
            // Close all
            $('.interval__item').addClass('interval__item--hide');

            current.removeClass('interval__item--hide');;
        } else {
            current.addClass('interval__item--hide');
        }

        $('html, body').scrollTop(
            scrolltarget
        );

        window.accommodationSlider(current);
    });

    $('.interval__image--thumb').on('click', function (e) {
        var id = $(this).data('ident');


        $(this).parent().find('.interval__image--thumb.interval__image--hide').removeClass('interval__image--hide');

        $(this).addClass('interval__image--hide');
        $(this).parent().find('.interval__image-container').after($(this));


        $(this).parent().find('.interval__image--big').addClass('interval__image--hide');
        $(this).parent().find('.interval__image--big[data-ident="' + id + '"]').removeClass('interval__image--hide');

    });

    $('.js-why-ot__button').on('click', function(e) {
        e.preventDefault();
        $('html, body').animate(
            {
                scrollTop: $('.js-detail-title').offset().top - 200,
            },
            800
        );
    });
});
